export const checkDueDiligenceCompleteness = (finalPayload, requiredEnums) => {
  if (!finalPayload || !Array.isArray(finalPayload)) {
    return {
      isComplete: false,
      missingLabels: Object.values(requiredEnums),
    }
  }

  const requiredLabels = Object.values(requiredEnums)

  // Create a Set of labels present in the finalPayload for efficient lookup
  const presentLabels = new Set(finalPayload.map(item => item?.label))

  // Find which required labels are NOT present
  const missingLabels = requiredLabels.filter(label => !presentLabels.has(label))

  return {
    isComplete: missingLabels.length === 0,
    missingLabels,
  }
}

export const addSpacesToLabel = label => {
  if (!label || typeof label !== 'string') {
    return label
  }
  // e.g., "RiskManagement" -> "Risk Management"
  let formattedLabel = label.replace(/([a-z])([A-Z])/g, '$1 $2')

  formattedLabel = formattedLabel.replace(/([A-Z])([A-Z][a-z])/g, '$1 $2')

  return formattedLabel
}

// Helper function to store the original URL
export const storeOriginalUrl = url => {
  if (url) {
    localStorage.setItem('intendedUrl', url)
  }
}

// Helper function to get and clear the original URL
export const getAndClearIntendedUrl = () => {
  const url = localStorage.getItem('intendedUrl')
  localStorage.removeItem('intendedUrl')
  return url
}

// Helper function to determine if a route requires authentication
export const routeRequiresAuth = route => !(route.matched.some(record => record.meta.requiresAuth === false
    || record.meta.resource === 'Auth'
    || record.meta.action === 'read'))

export const formatFullName = person => {
  if (!person) {
    return ''
  }
  const nameParts = [person.lastname, person.firstname, person.othernames].filter(Boolean)
  return nameParts.join(' ')
}
